export const CATEGORY_LIST_REQUEST = 'CATEGORY_LIST_REQUEST';
export const CATEGORY_LIST_SUCCESS = 'CATEGORY_LIST_SUCCESS';
export const CATEGORY_LIST_FAILURE = 'CATEGORY_LIST_FAILURE';

export const PRODUCT_LIST_REQUEST = 'PRODUCT_LIST_REQUEST';
export const PRODUCT_LIST_SUCCESS = 'PRODUCT_LIST_SUCCESS';
export const PRODUCT_LIST_FAILURE = 'PRODUCT_LIST_FAILURE';

export const ORDER_SET_TYPE = 'ORDER_SET_TYPE';
export const ORDER_REMOVE_ITEM = 'ORDER_REMOVE_ITEM';
export const ORDER_ADD_ITEM = 'ORDER_ADD_ITEM';
export const ORDER_CLEAR = 'ORDER_CLEAR';

export const PAYMENT_SET_TYPE = 'PAYMENT_SET_TYPE';

export const ORDER_CREATE_REQUEST = 'ORDER_CREATE_REQUEST';
export const ORDER_CREATE_SUCCESS = 'ORDER_CREATE_SUCESS';
export const ORDER_CREATE_FAILURE = 'ORDER_CREATE_FAILURE';

export const ORDER_LIST_REQUEST = 'ORDER_LIST_REQUEST';
export const ORDER_LIST_SUCCESS = 'ORDER_LIST_SUCCESS';
export const ORDER_LIST_FAILURE = 'ORDER_LIST_FAILURE';

export const SCREEN_SET_WIDTH = 'SCREEN_SET_WIDTH';

export const ORDER_QUEUE_REQUEST = 'ORDER_QUEUE_REQUEST';
export const ORDER_QUEUE_SUCCESS = 'ORDER_QUEUE_SUCCESS';
export const ORDER_QUEUE_FAILURE = 'ORDER_QUEUE_FAILURE'; 
